import Quill from "quill";
export default class InputQuill{
    
    constructor(element) {
        this._wrapper = element;
        this._editor = this._wrapper.querySelector('.js-input-quill-editor');
        this._textarea = this._wrapper.querySelector('textarea');
        
        this.init();
    }
    
    init(){
        this.quill = new Quill(this._editor,{
            modules: {
                toolbar: [
                    // [{ header: [2, 3, false] }],
                    ['bold', 'italic'],
                    ['link'],
                    [{ list: 'bullet' },{ list: 'ordered' }],
                ],
            },
            theme: 'snow',
        });
        this.quill.on('text-change', () => {
            this._textarea.value = this.quill.root.innerHTML;
        });
    }
    
}